function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-newsletter"), React.createElement("g", {
  id: "icon-newsletter-icon-newsletter",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M5.54799023,78.1117641 L5.54799023,26.2401483 L50.0626096,65.1291677 L94.4512271,26.4148899 L94.4512271,78.1117641 L5.54799023,78.1117641 Z M90.4301277,22.5549026 L50.06574,57.7594599 L9.76865765,22.5549026 L90.4301277,22.5549026 Z M0,83.6666667 L100,83.6666667 L100,17 L0,17 L0,83.6666667 Z",
  id: "icon-newsletter-Fill-9",
  fill: "#000"
}))));